import styles from './BlogEmbeddedProfileWithCaption.module.css';

const BlogEmbeddedProfileWithCaption = ({src, caption, ...props}) => {
  return (
    <div className="relative flex flex-col items-center">
      <div className={styles.nextContainer}>
        <iframe src={src} className={`!mb-2 ${styles.iframe}`} {...props} />
      </div>
      <span className="text-sm italic">{caption}</span>
    </div>
  );
};

export default BlogEmbeddedProfileWithCaption;
